export class AddOrEditSubcategoryModel {
  public id: string;
  public name: string;
  public description: string;
  public parentId: string;
  public companyId: string;
  public languageId: string;
  public pictureURL: string;
}
